import { ResponsePanelItemView } from '../view/ResponsePanelItemView';
import { templateResponsePanelItem } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../framework/BaseWebComponentController';
import { ResponsePanelItemWebComponent } from '..';
import { ResponsePanelItemWebComponentSchema } from '../types';

export class ResponsePanelItemController extends BaseWebComponentController {
  public component: ResponsePanelItemWebComponent;
  public view: ResponsePanelItemView;
  public viewConstructor: typeof ResponsePanelItemView;

  constructor(component: ResponsePanelItemWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: ResponsePanelItemView,
      viewTemplate: templateResponsePanelItem,
    });
  }

  async getDataForView(): Promise<ResponsePanelItemWebComponentSchema> {
    return {
      actionCategoryName: this.component.actionCategoryName,
      actions: this.component.actions,
      view: this.component.view,
      category: this.component.category,
    };
  }
}
